import RefreshIconMUI from "@mui/icons-material/Refresh";
import { Button, IconButton, LinearProgress } from "@mui/material";
import PropTypes from "prop-types";

import { CircularProgressWithLabel } from "../Progress/CircularProgressWithLabel";

export default function RefreshIcon(props) {
  const handleKlik = () => props.onClick();

  const variant = props.variant || "outlined";
  const size = props.size || "medium";
  const fontSize = props.fontSize || 25;
  const iconButton = props.iconButton || false;
  const isLoading = props.isLoading || false;
  const disabled = props.disabled || false;
  const isBackgroundLoading = props.isBackgroundLoading || false;
  const height = props.height || "40px";
  const buttonProps = props.buttonProps || {};

  return (
    <div
      className="center noPrint transitionElement flexCol"
      style={{
        height: "100%",
      }}>
      {iconButton ? (
        <>
          <IconButton
            size={size}
            variant={variant}
            onClick={handleKlik}
            disabled={disabled}
            aria-label="Päivitä">
            <RefreshIconMUI sx={{ fontSize: fontSize }} />
          </IconButton>
        </>
      ) : (
        <>
          <Button
            size={size}
            variant={variant}
            onClick={handleKlik}
            disabled={disabled}
            sx={{ height: height }}
            aria-label="Päivitä"
            {...buttonProps}>
            {isLoading ? (
              <CircularProgressWithLabel size={36} value={props.isLoadedPercent} />
            ) : (
              <RefreshIconMUI sx={{ fontSize: fontSize }} />
            )}
          </Button>
          {isBackgroundLoading && (
            <div style={{ position: "relative", opacity: 0.5 }}>
              <LinearProgress sx={{ height: "1px", width: "100%", top: -2 }} />
            </div>
          )}
        </>
      )}
    </div>
  );
}

RefreshIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  fontSize: PropTypes.number,
  size: PropTypes.string,
  iconButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadedPercent: PropTypes.number,
  isBackgroundLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  buttonProps: PropTypes.object,
};
